<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="案件状态">
              <el-select v-model="caseStatus" style="width: 100%;" placeholder="请选择或输入案件状态"
                         filterable clearable multiple collapse-tags>
                <el-option
                  v-for="item in caseStatusOption"
                  :key="item.modelName"
                  :label="item.modelName"
                  :value="item.modelName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开关">
              <el-select
                v-model="status"
                clearable
                filterable
                allow-create
                placeholder="请选择开关状态"
                style="width: 100%;">
                <el-option value="1" label="启用" key="1" ></el-option>
                <el-option value="0" label="禁用" key="0" ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" @click="search" :icon="'el-icon-search'">搜索</el-button>
              <el-button @click="resetSearch" :icon="'el-icon-refresh'">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="add">添加案件状态</el-button>
      </p>
    </div>
    <div class="padding15-tb">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        @sort-change="sortChange"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          sortable="custom"
          width="180">
        </el-table-column>
        <el-table-column
          prop="modelName"
          align="center"
          label="案件状态">
        </el-table-column>
        <el-table-column
          prop="modelCode"
          align="center"
          label="状态代码">
        </el-table-column>
        <el-table-column
          align="center"
          label="是否执行策略">
          <template slot-scope="scope">
            <span>{{scope.row.strategy === '1' ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="edit(scope.row)"></el-button>
            &nbsp;
            <el-switch
              @change="updateStatus(scope.row)"
              v-model="scope.row.status">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
    <!-- 添加案件状态 -->
    <el-dialog
      :visible.sync="addCaseStatusVisible"
      :title="dialogTitle"
      center
      width="70%">
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="状态名称">
                <el-input v-model="req.modelName" placeholder="请输入10字以内的状态名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否执行策略">
                <el-select v-model="req.strategy" style="width: 100%;" placeholder="请选择" filterable>
                  <el-option
                    v-for="item in execStrategyOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="状态代码">
                <el-input v-model="req.modelCode" placeholder='请输入20字以内的状态代码' :disabled="isEdit"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="立即生效">
                <el-switch v-model="req.status"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="状态描述">
                <el-input v-model="req.remark" type="textarea" resize="none" placeholder="请输入状态描述" :rows="4"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCaseStatusVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addOrEdit" size="small">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    getCaseStatusParam: {
      type: Function,
      default() {
      }
    },
    changeTabe: {
      type: String
    },
    caseStatusOption: {
      type: Array
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '案件状态') {
        this.getData(1);
      }
    }
  },
  data() {
    return {
      loading: true,
      dialogTitle: '',
      addCaseStatusVisible: false,
      execStrategyOption: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ],
      list: [],
      pageData: {},
      modelType: 'CaseStatus',
      caseStatus: [],
      status: null,
      sort: {
        order: '',
        sort: ''
      },
      defaultSort: {
        order: 'id',
        sort: 'asc'
      },
      req: {
        id: '',
        modelName: '',
        modelCode: '',
        strategy: '',
        status: '',
        remark: ''
      },
      isEdit: ''
    };
  },
  methods: {
    resetSearch() {
      this.caseStatus = [];
      this.status = null;
      this.getData(1);
    },
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/dict/list',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        const self = this;
        self.list = res.data.list;
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.loading = false;
      });
    },
    getSearchParam(page) {
      const req = {
        'modelType': this.modelType,
        'modelNames': this.caseStatus,
        'status': this.status,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': this.sort.order || this.defaultSort.order,
        'sort': this.sort.sort || this.defaultSort.sort
      };
      return req;
    },
    getDataByFirst(page) {
      this.getData(page);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getSengRuleData(val);
    },
    search() {
      this.getData(1);
    },
    sortChange(data) {
      if (!data.prop) {
        return;
      }
      this.sort.order = data.prop;
      if (data.order === 'ascending') {
        this.sort.sort = 'asc';
      } else {
        this.sort.sort = 'desc';
      }
      this.getData(1);
    },
    add() {
      this.dialogTitle = '添加案件状态';
      this.addCaseStatusVisible = true;
      this.isEdit = false;
      this.req = {
        id: '',
        modelName: '',
        modelCode: '',
        strategy: '',
        status: true,
        remark: ''
      };
    },
    edit(row) {
      this.dialogTitle = '编辑案件状态';
      this.addCaseStatusVisible = true;
      this.isEdit = true;
      this.req = {
        id: row.id,
        modelName: row.modelName,
        modelCode: row.modelCode,
        strategy: row.strategy,
        status: row.status,
        remark: row.remark
      };
    },
    addOrEdit() {
      if (!this.checkAddOrEditParmas()) return;
      this.$ajax({
        url: '/dict/addOrUpdateCaseStatus',
        prompt: true,
        method: 'POST',
        data: this.req
      }).then(() => {
        this.addCaseStatusVisible = false;
        this.search();
        this.getCaseStatusParam();
      });
    },
    checkAddOrEditParmas() {
      if (!this.req.modelName) {
        this.$message({
          message: '请输入状态名称',
          type: 'warning'
        });
        return false;
      }
      if (this.req.modelName.length > 10) {
        this.$message({
          message: '状态名称10字以内',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.modelCode) {
        this.$message({
          message: '请输入状态代码',
          type: 'warning'
        });
        return false;
      }
      if (this.req.modelCode.length > 20) {
        this.$message({
          message: '状态代码20字以内',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.strategy) {
        this.$message({
          message: '请选择是否执行策略',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.remark) {
        this.$message({
          message: '请输入状态描述',
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    updateStatus(row) {
      this.$ajax({
        url: '/dict/addOrUpdateCaseStatus',
        prompt: true,
        method: 'POST',
        data: { 'id': row.id, 'status': row.status }
      }).then(() => {
        this.search();
        this.getCaseStatusParam();
      }).catch(() => {
        row.status = !row.status;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/case_status.vue